import { validateStepsByValidationResults } from 'sos-eservice-common/js/Redux/Reducers/validation.helpers';
import { ResearchOrderProps } from './ResearchOrder.types';
import { researchOrderGlobals } from '../../models';

export function getInitialState(props: ResearchOrderProps) {
  const {
    orderId,
    model,
    translations,
    externalRegistries,
    internalRegistriescauseOfDeath,
    internalRegistrieshealthData,
    internalRegistriessocialServices,
    qualityRegistries,
    purposeForSaveSerialNoOptions,
    files,
    validationResults,
    homePageUrl,
    thankYouPageUrl,
  } = props;

  const registers = {
    externalRegistries,
    internalRegistriescauseOfDeath,
    internalRegistrieshealthData,
    internalRegistriessocialServices,
    qualityRegistries
  };

  const globals = {
    homePageUrl,
    thankYouPageUrl,
    orderId,
    translations,
    purposeForSaveSerialNoOptions,
    shouldShowDelete: !!orderId,
    currentStep: 1,
    hasHitSummary: false,
    isSending: false,
    touchedMap: new Map<any, any>(),
  } as Partial<researchOrderGlobals>;

  const initValidationState = {
    validationResults,
    fullValidationResults: validationResults,
    stepValidationMap: {
      0: {
        isValid: false,
        stepId: 0
      },
      1: {
        isValid: false,
        stepId: 1
      },
      2: {
        isValid: false,
        stepId: 2
      },
      3: {
        isValid: false,
        stepId: 3
      }
    },
    touchedFields: []
  };

  const validatedValidationState = validateStepsByValidationResults(
    initValidationState
  );

  return {
    formModel: model,
    globals,
    registers,
    files,
    validationState: validatedValidationState
  };
}
